document.addEventListener('DOMContentLoaded', function() {
  const slideLinks = [
    { match: 'TAB_10', link: '/products/itel-vista-tab-10-128-4-10-inch?_pos=1&_sid=7720492b5&_ss=r' },
    { match: 'tech-image-for-mobiles', link: '/collections/home-appliance' }
  ];

  const slideshow = document.querySelector('.slideshow');
  if (!slideshow) return;

  // delegate click to the slideshow container
  slideshow.addEventListener('click', function(e) {
    // get the closest slide container from where the click originated
    const slide = e.target.closest('.slideshow__slide');
    if (!slide) return;

    // find the visible image in this slide
    const img = slide.querySelector('img');
    if (!img) return;

    const src = img.getAttribute('src');
    const match = slideLinks.find(item => src.includes(item.match));
    if (match) {
      window.location.href = match.link;
    }
  });

  // continuously update cursor on visible slides
  function updateCursors() {
    slideshow.querySelectorAll('.slideshow__slide').forEach(slide => {
      // only pointer on visible slides
      if (slide.getAttribute('aria-hidden') === 'false') {
        slide.style.cursor = 'pointer';
      } else {
        slide.style.cursor = 'default';
      }
    });
  }

  // initial call + observe DOM changes
  updateCursors();
  const observer = new MutationObserver(updateCursors);
  observer.observe(slideshow, { attributes: true, subtree: true, attributeFilter: ['aria-hidden'] });
});
